import * as S from './styles';

export function Footer() {
  return (
    <S.Footer />
  );
}
